import { createBrowserHistory } from 'history';

/**
 * 
 * @param externalUrl 
 * @returns shortened link
 */
export const shortenLinkT1 = ( externalUrl ) => {
    if(externalUrl) {
      return `${externalUrl.slice(0, 10)}...${externalUrl.slice(externalUrl.length-10)}`
    }
    return null;
}

// validate mail 
export const validateMmailAddress = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

// get number of days between two dates
export const daysDifference = (date_1, date_2) => {
  date_1 = new Date(date_1);
  date_2 = new Date(date_2);
  let difference = date_1.getTime() - date_2.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return TotalDays;
}

// get bearer token
export const getAuthToken = () => localStorage?.authToken

// is user signed-in
export const isAuthed = () => !!localStorage.authToken;

// navigation
export const navigate = createBrowserHistory();


